import CartRewardBanner from '@/components/cart-reward-banner';

document.addEventListener('DOMContentLoaded', () => {
  window.theme.cartRewardBanner.instance = new CartRewardBanner({
    rewardTiers: window.theme.cartRewardBanner.rewardTiers ?? [],
    cartTotal: window?.theme?.cartRewardBanner?.cartTotal
      ? window.theme.cartRewardBanner.cartTotal / 100
      : 0,
    rootElement: document.querySelector('.cart-reward-banner')!,
    blacklistedProperties: ['__free_gift'],
    verbose: true,
  });
});
